import React, { useState } from "react";

import { useLocation } from "react-router-dom";

// components
import Button from "../Button/Button";
import Typography from "../Typography/Typography";

// styled components
import { Menu, MenuItem, Nav, NavLink } from "./navbarStyle";

// icons
import { Icon } from "../Sidebar/sidebarStyle";
import { useRecoilState } from "recoil";
import { locationUrlAtom } from "../../shared/locationUrl";
import { AiOutlinePlus } from "react-icons/ai";
import { SearchUser } from "../SearchUser/SearchUser";

const Navbar = ({ menuList, Crm, handleShow }) => {
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [locationUrl, setLocationUrl] = useRecoilState(locationUrlAtom);
  const location = useLocation();
  return (
    <Nav>
      <Menu className="row">
        {menuList.map((item, index) => (
          <MenuItem
            className={
              item?.child?.includes(location.pathname)
                ? "active col-lg-2 col-4 mb-2"
                : "col-lg-2 col-4 mb-2"
            }
            // className={
            //   location.pathname === item.path
            //     ? "active col-lg-2 col-4 mb-2"
            //     : "col-lg-2 col-4 mb-2"
            // }
            key={index}
            onMouseEnter={() =>
              item.subMenu?.length > 1 ? setIsShowDropdown(true) : null
            }
            onMouseLeave={() =>
              item.subMenu?.length > 1 ? setIsShowDropdown(false) : null
            }
          >
            <NavLink to={item.path} onClick={() => setLocationUrl(item.name)}>
              <Icon>{item?.icon}</Icon>
              <Typography space=".3rem" size="14px">
                {item.name}
              </Typography>
            </NavLink>
          </MenuItem>
        ))}
        {Crm ? (
          <>
            <MenuItem className="d-flex" style={{ justifyContent: "left" }}>
              <SearchUser className="" />
              <Button
                bgColor="#0d6efd"
                color="#fff"
                onclick={handleShow}
                className="d-flex m-0 mx-1"
                small="fit-content"
                style={{
                  height: "39px",
                  display: "flex !important",
                  alignItems: "center",
                }}
              >
                <AiOutlinePlus />
                <Typography primary="#fff" size="12px" className="mx-1">
                  افزودن
                </Typography>
              </Button>
            </MenuItem>
          </>
        ) : null}
      </Menu>
    </Nav>
  );
};

export default Navbar;
